import React from "react";
import SMACDashboard from "./index";
import {VIEW_BY_USAGE} from "./constants";


export default function DashboardUsageInstance() {
    return <SMACDashboard title="SMAC Usage" fixedTabValue={VIEW_BY_USAGE} />
}